import React, { useState } from "react";
import { Container, Tab, Nav, Card, ListGroup, Image, Button } from "react-bootstrap";
import Footer from '../Footer/Footer';

const NotificationPage = () => {
  const [key, setKey] = useState("proposals");
  const [notifications, setNotifications] = useState({
    proposals: [
      { companyLogo: 'https://logo.clearbit.com/apple.com', companyName: 'Apple', message: 'New proposal received!' },
      { companyLogo: 'https://logo.clearbit.com/microsoft.com', companyName: 'Microsoft', message: 'Proposal under review.' },
      { companyLogo: 'https://logo.clearbit.com/ibm.com', companyName: 'IBM', message: 'Proposal needs revision.' },
      { companyLogo: 'https://logo.clearbit.com/oracle.com', companyName: 'Oracle', message: 'Proposal approved for next stage.' },
      { companyLogo: 'https://logo.clearbit.com/salesforce.com', companyName: 'Salesforce', message: 'Client has requested changes.' }
    ],
    messages: [
      { companyLogo: 'https://logo.clearbit.com/amazon.com', companyName: 'Amazon', message: 'New message: "Let’s discuss further."' },
      { companyLogo: 'https://logo.clearbit.com/google.com', companyName: 'Google', message: 'Follow-up required on previous message.' },
      { companyLogo: 'https://logo.clearbit.com/facebook.com', companyName: 'Facebook', message: 'You have a missed call.' },
      { companyLogo: 'https://logo.clearbit.com/twitter.com', companyName: 'Twitter', message: 'Your tweet received a reply.' },
      { companyLogo: 'https://logo.clearbit.com/linkedin.com', companyName: 'LinkedIn', message: 'New connection request.' }
    ],
    forum: [
      { companyLogo: 'https://logo.clearbit.com/tesla.com', companyName: 'Tesla', message: 'Someone liked your post!' },
      { companyLogo: 'https://logo.clearbit.com/netflix.com', companyName: 'Netflix', message: 'New comment on your topic.' },
      { companyLogo: 'https://logo.clearbit.com/reddit.com', companyName: 'Reddit', message: 'Your post was upvoted!' },
      { companyLogo: 'https://logo.clearbit.com/stackoverflow.com', companyName: 'Stack Overflow', message: 'Your answer was marked as accepted.' },
      { companyLogo: 'https://logo.clearbit.com/quora.com', companyName: 'Quora', message: 'You have a new question suggestion.' }
    ],
    following: [
      { companyLogo: 'https://logo.clearbit.com/spotify.com', companyName: 'Spotify', message: 'New update from an artist you follow.' },
      { companyLogo: 'https://logo.clearbit.com/adobe.com', companyName: 'Adobe', message: 'A new blog post is available.' },
      { companyLogo: 'https://logo.clearbit.com/medium.com', companyName: 'Medium', message: 'New article recommended for you.' },
      { companyLogo: 'https://logo.clearbit.com/github.com', companyName: 'GitHub', message: 'A repository you follow was updated.' },
      { companyLogo: 'https://logo.clearbit.com/behance.net', companyName: 'Behance', message: 'A designer you follow uploaded new work.' }
    ]
  });

  const handleActionClick = (companyName, message) => {
    console.log(`Action clicked for ${companyName}: ${message}`);
  };

  const clearNotifications = (tabKey) => {
    setNotifications((prevNotifications) => ({
      ...prevNotifications,
      [tabKey]: []
    }));
  };

  return (
    <>
    <div className="js-pg-hg mt-4">
          <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="heading mb-3 mt-4 pb-1">
                <h4>Notification</h4>
              </div>

              <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                <Nav variant="tabs" className="mb-3">
                  <Nav.Item>
                    <Nav.Link eventKey="proposals" className="pb-3 px-3">Proposals</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="messages" className="pb-3 px-3">Messages</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="forum" className="pb-3 px-3">Forum</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="following" className="pb-3 px-3">Following</Nav.Link>
                  </Nav.Item>
                </Nav>
                <Tab.Content>
                  {Object.keys(notifications).map((tabKey) => (
                    <Tab.Pane eventKey={tabKey} key={tabKey}>

                      <Card className="notification_list bg-transparent py-2 border-0">
                        <ListGroup className="list-unstyled bg-white p-0 m-0">
                          {notifications[tabKey].map((item, index) => (
                            <ListGroup.Item key={index} className="d-flex align-items-center justify-content-between p-3 m-0">
                              <div className="d-flex align-items-center">
                                <Image src={item.companyLogo} roundedCircle width={30} height={30} className="me-3 rounded-circle" />
                                <div>
                                  <h6 className="p-0 m-0">{item.companyName}</h6>
                                  <p className="m-0 p-0 mt-1 small text-muted">{item.message}</p>
                                </div>
                              </div>
                              <button className="btn btn-sm btn-outline-primary text-primary" onClick={() => handleActionClick(item.companyName, item.message)}>
                                View
                              </button>
                            </ListGroup.Item>
                          ))}
                        </ListGroup>
                      </Card>
                      <div className="mt-3 d-flex justify-content-end">
                      <Button variant="danger" size="sm" onClick={() => clearNotifications(tabKey)}>
                        Clear All
                      </Button>
                      </div>
                    </Tab.Pane>
                  ))}
                </Tab.Content>
              </Tab.Container>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default NotificationPage;